import React from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import Cookie from 'js-cookie'
import ENVCONFIG from '@env'

interface IP extends RouteComponentProps<any> {
  isLogin: boolean
  userStore?: IUserStore.UserStore
}

@inject('userStore')
@observer
class LoginChecker extends React.Component<IP> {
  render() {
    const isSoft = Cookie.get('AUTHOR_PROJECT') === 'soft'

    if (!this.props.isLogin || !isSoft) {
      return (
        ENVCONFIG.env !== 'dev' && (window.location.href = ENVCONFIG.loginPage)
      )
    } else {
      if (!localStorage.getItem('USER_INFO')) {
        this.props.userStore.initUserInfo()
      }
      return this.props.children
    }
  }
}

export default withRouter(LoginChecker)
